import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordCheckCircleAltIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 11.08V12c-.001 2.1492-.7146 4.2346-2.0296 5.9463-1.315 1.7117-3.1652 2.9355-5.2394 3.4674-2.0742.5319-4.2709.4465-6.2952-.2432-2.02429-.6897-3.78439-1.9958-4.99093-3.7097-1.20654-1.7139-1.81651-3.7504-1.73401-5.8156.08251-2.0652.77018-4.0524 1.95926-5.66563C4.87897 4.39128 6.49227 3.27937 8.31599 2.72343c1.82371-.55595 3.76841-.54276 5.58401.03787M22 4L12 14.01l-3-3"
      />
    </svg>
  );
};

export default BordCheckCircleAltIcon;